var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
/* eslint-disable react/jsx-props-no-spreading */
import React, { useState } from 'react';
import Input from '.';
export var EngNumErrorText = '請輸入英數字。';
var charEngNum = [
    'A',
    'B',
    'C',
    'D',
    'E',
    'F',
    'G',
    'H',
    'J',
    'K',
    'L',
    'M',
    'N',
    'P',
    'Q',
    'R',
    'S',
    'T',
    'U',
    'V',
    'X',
    'Y',
    'W',
    'Z',
    'I',
    'O',
    'a',
    'b',
    'c',
    'd',
    'e',
    'f',
    'g',
    'h',
    'j',
    'k',
    'l',
    'm',
    'n',
    'p',
    'q',
    'r',
    's',
    't',
    'u',
    'v',
    'x',
    'y',
    'w',
    'z',
    'i',
    'o',
    '0',
    '1',
    '2',
    '3',
    '4',
    '5',
    '6',
    '7',
    '8',
    '9',
    '@',
    '$',
    '!',
    '%',
    '*',
    '?',
    '#',
];
export var EngNumCheck = function (value) {
    var errIdx = value
        .split('')
        .findIndex(function (obj) { return charEngNum.indexOf(obj) === -1; });
    return errIdx === -1;
};
export var EngNumError = function (value) { return !EngNumCheck(value); };
export var MultiEngNumCheck = function (value, eachNum) {
    if (eachNum === void 0) { eachNum = 10; }
    return value
        .split(',')
        .every(function (obj) { return ((obj || '').length === eachNum || 0) && EngNumCheck(obj); });
};
export var MultiEngNumError = function (value) {
    return !MultiEngNumCheck(value);
};
var InputEngNum = function (props) {
    var error = props.error, helperText = props.helperText, onChange = props.onChange, other = __rest(props, ["error", "helperText", "onChange"]);
    var _a = useState(''), message = _a[0], setMessage = _a[1];
    return (React.createElement(Input, __assign({}, other, { error: error || message.length > 0, helperText: message || helperText, onChange: function (e) {
            var value = e.target.value;
            if (value.length > 0 && EngNumError(value)) {
                setMessage(EngNumErrorText);
                return;
            }
            setMessage('');
            if (onChange) {
                onChange(e);
            }
        } })));
};
export default InputEngNum;
